module.exports = __webpack_public_path__ + "img/main_logo_svg.bc4c9e5b.svg";